// src/components/CategoryCard.js

import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import './CategoryCard.css'; // Assuming you have a dedicated CSS file

// Utility function to convert title to a URL-friendly slug
const toSlug = (title) => {
    return title.toLowerCase().replace(/ & /g, '').replace(/ /g, '-').replace(/[^a-z0-9-]/g, '');
};

const CategoryCard = ({ title, description, icon }) => {
  
  // 1. Generate the dynamic path slug
  const pathSlug = toSlug(title);

  return (
    // 2. Wrap the card in a Link component pointing to the PathPage route
    <Link to={`/explore/${pathSlug}`} className="category-link">
      <div className="category-card glossy-card">
        
        <div className="card-icon-wrapper">
          <img 
            src={icon} 
            alt={`${title} icon`} 
            className="category-icon-image"
            // Optional: Add a subtle loading placeholder if needed
          />
        </div>

        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        
        <span className="explore-link-arrow">
          Explore Path →
        </span>
      </div>
    </Link>
  );
};

export default CategoryCard;